import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'home-shrink-header-slider',
  templateUrl: './shrink-header-slider.component.html',
  styleUrls: ['./shrink-header-slider.component.scss'],
})
export class ShrinkHeaderSliderComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
